const DiagramDefinitionsBuilder = function (core) {

    const getRefs = function (defName, fieldDefs) {
        return fieldDefs.reduce((acc, fd) => {
            if (fd.configuration.keys.Reference &&
                (!fd.configuration.keys.AutoRefField || fd.configuration.extensions.$includeInMermaid) ) {
                acc.push({
                    one: fd.configuration.keys.Reference.args.definition,
                    many: defName,
                    fieldName: fd.name,
                    required: Boolean(fd.required)
                });
            }
            if (fd.fields) acc.push(...getRefs(defName, fd.fields));
            return acc;
        }, [])
    }

    const getReferences = function (defName, fieldDefs) {
        return fieldDefs.reduce((acc, fd) => {
            if (fd.configuration.keys.References) {
                acc.push({
                    one: defName,
                    many: fd.configuration.keys.References.args.definition
                });
            }
            if (fd.fields) acc.push(...getReferences(defName, fd.fields));
            return acc;
        }, [])
    }

    const uniqBy = function (a, key) {
        const seen = new Set();
        return a.filter((item) => {
            const k = key(item);
            return seen.has(k) ? false : seen.add(k);
        });
    }

    const toMermaidId = function (name) {
        return name.normalize("NFD")
            .replace(/\p{Diacritic}/gu, "")
            .replace(/\./g, "_")
            .replace(/ /g, "_");
    }

    const _build = function (defs, confs) {
        console.debug("Building diagram with confs", confs)

        let refs = [];
        let references = [];

        const tables = new Set();
        for (const def of defs) {
            refs.push(...getRefs(def.name, def.fieldDefinitions));
            references.push(...getReferences(def.name, def.fieldDefinitions));
            tables.add(def.name);
        }

        refs = uniqBy(refs, (r) => r.one + ":" + r.many)
        references = uniqBy(references, (r) => r.one + ":" + r.many)


        // ---------------------------------------------
        // -- draw the mermaid diagram
        const mermaidLines = ["erDiagram", ""]

        for (const table of tables) {
            const id = toMermaidId(table)
            mermaidLines.push(`\t${id}["${table}"]{}`)
        }

        for (const ref of refs) {
            if (confs.showReferences || (tables.has(ref.one) && tables.has(ref.many))) {
                const one = toMermaidId(ref.one);
                const many = toMermaidId(ref.many);
                const left = '|o';
                const right = (ref.required ? '|' : 'o') + '{';

                const msgType = references.some((r) => r.one === ref.one && r.many === ref.many) ? "hasMany" : "isOf"
                let msg = "";

                if (confs.showLabels) {
                    switch (core.getLanguage()) {
                        case "pt":
                            msg = msgType === "hasMany" ? `${ref.one} têm ${ref.many}` : `_${ref.fieldName}_ refere um registo de ${ref.one}`;
                            break;
                        case "es":
                            msg = msgType === "hasMany" ? `${ref.one} tienen ${ref.many}` : `_${ref.fieldName}_ se refiere a un registro de ${ref.one}`;
                            break;
                        default:
                            msg = msgType === "hasMany" ? `${ref.one} have many ${ref.many}` : `_${ref.fieldName}_ is one of ${ref.one}`;
                            break;
                    }
                }

                mermaidLines.push(`\t${one} ${left}..${right} ${many}: " ${msg}"`)
            }
        }

        return mermaidLines.join("\n")
    }

    return {
        build: _build
    }
}

export default DiagramDefinitionsBuilder;